<template>
  <a-layout class="left_right_layout">
    <a-layout-content class="left_right_layout_content" style="flex: 1;flex-basis: 1000px;min-width: 800px;">
      <slot name="center_content"></slot>
    </a-layout-content>
    <a-layout-sider class="left_right_layout_sider" style="flex:1 0 310px;max-width: 313px" v-if="showSider">
      <a-layout style="height:100%;">
<!--        <a-layout-header>选择条件</a-layout-header>-->
        <a-layout-content>
          <slot name="sider_content"></slot>
          <div>
            <a-button @click="reset" class="reset_button">{{ $t('baseVO.reset') }}</a-button>
          </div>
          <slot name="other"></slot>
        </a-layout-content>
      </a-layout>
    </a-layout-sider>
  </a-layout>
</template>

<script>
  export default {
    name: 'leftRightLayout',
    props:{
      showSider:{
        type: Boolean,
        default: false,
      }
    },
    methods:{
      reset(){
        console.log('重置选项')
        this.$emit('reset')
      }
    }
  }
</script>

<style lang="less" scoped>
  .left_right_layout{
    margin-bottom: 20px;
    .left_right_layout_content{
      background: #FFFFFF;
      border: 1px solid #EAEAEA;
      -webkit-border-radius: 10px;
      -moz-border-radius: 10px;
      border-radius: 10px;
    }
    .left_right_layout_sider{
      padding: 20px 0px;
      background: #FFFFFF;
      border: 1px solid #EAEAEA;
      -webkit-border-radius: 10px;
      -moz-border-radius: 10px;
      border-radius: 10px;
      margin-left: 20px;
      .ant-layout-header{
        padding:0px 10px 18px 5px;
        background: #FFFFFF;
        border-bottom: 1px solid #EAEAEA;
        font-size: 18px;
        color: #333333;
        font-weight: bold;
        line-height: inherit;
        height:auto;
      }
      .ant-layout-content{
        background: #FFFFFF;
        justify-content: center;
        div{
          border-top: 1px solid #EAEAEA;
          padding-top: 23px;
          display: flex;
          justify-content: center;
          .reset_button{
            width: 170px;
          }
        }
      }
    }
  }
</style>